export default function TermsPage() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-12 text-slate-300">
      <h1 className="text-2xl font-semibold text-slate-200 mb-2">Terms of Service</h1>
      <p className="text-xs text-slate-500 mb-8">Last updated: March 24, 2026</p>

      <section className="mb-6">
        <h2 className="text-sm font-semibold text-slate-200 mb-2 uppercase tracking-wide">1. Service Description</h2>
        <p className="text-sm leading-relaxed text-slate-400">
          The Navigator ("Service") is an AI-powered accountability and mentoring tool
          designed to help users set goals, track commitments, and build momentum during
          life transitions. The Service is provided by BeeLine Microsystems ("we", "us", "our").
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-sm font-semibold text-slate-200 mb-2 uppercase tracking-wide">2. Not Therapy or Crisis Counseling</h2>
        <p className="text-sm leading-relaxed text-slate-400">
          The Navigator is not a licensed therapist, counselor, or medical professional.
          It does not provide mental health treatment, diagnosis, or crisis intervention.
          If you are experiencing a mental health emergency, please contact the
          988 Suicide & Crisis Lifeline (call or text 988) or the Crisis Text Line
          (text HOME to 741741) immediately.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-sm font-semibold text-slate-200 mb-2 uppercase tracking-wide">3. Acceptable Use</h2>
        <p className="text-sm leading-relaxed text-slate-400">
          You agree to use the Service for its intended purpose: structured accountability
          and goal tracking. You may not use the Service to generate harmful, illegal,
          or abusive content, or to attempt to circumvent safety measures. We reserve
          the right to suspend or terminate accounts that violate these terms.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-sm font-semibold text-slate-200 mb-2 uppercase tracking-wide">4. Accounts & Authentication</h2>
        <p className="text-sm leading-relaxed text-slate-400">
          You must provide a valid email address to create an account. You are responsible
          for maintaining the security of your account credentials. You must be at least
          13 years of age to use this Service.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-sm font-semibold text-slate-200 mb-2 uppercase tracking-wide">5. Billing & Subscriptions</h2>
        <p className="text-sm leading-relaxed text-slate-400">
          Paid plans are billed through Stripe. Subscriptions renew automatically unless
          cancelled before the renewal date. Refunds are handled on a case-by-case basis.
          We may change pricing with 30 days' notice. Free-tier usage is subject to
          session limits as described on our pricing page.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-sm font-semibold text-slate-200 mb-2 uppercase tracking-wide">6. AI-Generated Content</h2>
        <p className="text-sm leading-relaxed text-slate-400">
          Responses from the Navigator are generated by artificial intelligence and may
          not always be accurate, complete, or appropriate for your specific situation.
          You should exercise your own judgment when acting on any suggestions. We are
          not liable for outcomes resulting from following AI-generated advice.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-sm font-semibold text-slate-200 mb-2 uppercase tracking-wide">7. Account Termination</h2>
        <p className="text-sm leading-relaxed text-slate-400">
          You may delete your account at any time, self-serve, from Settings; deletion
          permanently erases your data. We may suspend or terminate accounts that violate
          these terms or remain inactive for extended periods. Upon termination, your data
          will be deleted in accordance with our Privacy Policy.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-sm font-semibold text-slate-200 mb-2 uppercase tracking-wide">8. Limitation of Liability</h2>
        <p className="text-sm leading-relaxed text-slate-400">
          The Service is provided "as is" without warranties of any kind. To the maximum
          extent permitted by law, we shall not be liable for any indirect, incidental,
          special, or consequential damages arising from your use of the Service. Our
          total liability shall not exceed the amount you paid for the Service in the
          12 months preceding the claim.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-sm font-semibold text-slate-200 mb-2 uppercase tracking-wide">9. Changes to Terms</h2>
        <p className="text-sm leading-relaxed text-slate-400">
          We may update these terms from time to time. Continued use of the Service after
          changes constitutes acceptance of the updated terms. Material changes will be
          communicated via email or in-app notification.
        </p>
      </section>

      <section>
        <h2 className="text-sm font-semibold text-slate-200 mb-2 uppercase tracking-wide">10. Contact</h2>
        <p className="text-sm leading-relaxed text-slate-400">
          Questions about these terms? Contact us at{' '}
          <a href="mailto:support@beelinemicrosystems.com" className="text-blue-400 hover:text-blue-300">
            support@beelinemicrosystems.com
          </a>.
        </p>
      </section>
    </div>
  );
}
